<template>
  <div>
    <az-break-title title="Guias de Cobrança" />

    <div v-if="dados && dados.operadora && dados.operadora.fl_sus">
        <div class="card" style="padding: 0px;">
            <div class="card-body">
                <div class="row">
                    <div class="col col-12 col-md-3">
                        <az-input
                            label="Validade da Solicitação de Exames (em dias)"
                            type="number"
                            :validate="validate"
                            v-model="dados.in_validade_solicitacao_exame"
                            />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else-if="dados">
      <div class="card" style="padding: 0px;">
        <div class="card-body">
          <az-sub-title title="Contador para Guias" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                label="Inicial"
                type="number"
                :validate="validate"
                v-model="dados.in_inicio_contador_guia"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Final"
                type="number"
                :validate="validate"
                v-model="dados.in_fim_contador_guia"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Notificar Próximidade do Término do Contador"
                type="number"
                :validate="validate"
                v-model="dados.in_qtd_guias_fim_contador"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Contador para Guia de Consulta"
                type="checkbox"
                :validate="validate"
                v-model="dados.contador_guia_consulta"
              />
            </div>
          </div>

          <az-sub-title title="Contador de Faturas" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                label="Contador atual"
                type="number"
                :icon="contador_fatura_edit ? 'fas fa-check' : 'fas fa-pen'"
                :buttonText="contador_fatura_edit ? 'fas fa-check' : 'fas fa-pen'"
                :buttonIcon="true"
                :buttonColor="contador_fatura_edit ? 'outline-success' : 'outline-primary'"
                :edicao="contador_fatura_edit"
                v-model="contador_fatura"
                @clickButton="editarContadorFatura ()"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Contador Lote Fatura (todas as operadoras)"
                type="number"
                :icon="contador_lote_fatura_edit ? 'fas fa-check' : 'fas fa-pen'"
                :buttonText="contador_lote_fatura_edit ? 'fas fa-check' : 'fas fa-pen'"
                :buttonIcon="true"
                :buttonColor="contador_lote_fatura_edit ? 'outline-success' : 'outline-primary'"
                :edicao="contador_lote_fatura_edit"
                v-model="contador_lote_fatura"
                @clickButton="editarContadorLoteFatura ()"
              />
            </div>
          </div>

          <div v-if="dados.contador_guia_consulta">
            <az-sub-title title="Contador para Guia de Consulta" />
            <div class="row">
              <div class="col col-12 col-md-3">
                <az-input
                  label="Inicial"
                  type="number"
                  :validate="validate"
                  v-model="dados.in_inicio_contador_guia_consulta"
                />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Final"
                  type="number"
                  :validate="validate"
                  v-model="dados.in_fim_contador_guia_consulta"
                />
              </div>
              <div class="col col-12 col-md-3">
                <az-input
                  label="Notificar Próximidade do Término do Contador"
                  type="number"
                  :validate="validate"
                  v-model="dados.in_qtd_guias_consulta_fim_contador"
                />
              </div>
            </div>
          </div>

          <!-- Senha -->
          <az-sub-title title="Validação da Senha" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                label="Quantidade de Dígitos"
                type="number"
                :validate="validate"
                v-model="dados.in_digitos_validacao_senha"
              />
            </div>
            <div class="col col-12 col-md-3" v-if="1 == 0">
              <az-input
                label="Máscara"
                type="text"
                :validate="validate"
                v-model="dados.st_mascara_validacao_senha"
              />
            </div>
          </div>

          <az-sub-title title="Glosas" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                label="Prazo de Recurso de Glosas (dias)"
                type="number"
                :validate="validate"
                v-model="dados.in_prazo_recurso_glosa"
              />
            </div>
          </div>

          <!-- Outras Configurações -->
          <az-sub-title title="Impressão das Guias" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                type="select"
                placeholder="Padrão..."
                :optionsList="[
                  { id: 'N', search: 'Nenhuma' },
                  { id: '1', search: 'Guia 1 Página Total' }, 
                  { id: 'P', search: 'Guias Primeira Página' }, 
                  { id: 'T', search: 'Todas' }, 
                ]"
                optionsData="id"
                :validate="validate"
                v-model="dados.ch_imp_guia"
              />
            </div>
          </div>

          <!-- Outras Configurações -->
          <az-sub-title title="Outras Configurações" />
          <div class="row">
            <div class="col col-12 col-md-3">
              <az-input
                label="Validade da Solicitação de Exames (em dias)"
                type="number"
                :validate="validate"
                v-model="dados.in_validade_solicitacao_exame"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Limite de Itens por Guia"
                placeholder="Nenhum..."
                type="number"
                :validate="validate"
                v-model="dados.in_limite_itens_guia"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Qtde máxima de guias por arquivo XML"
                placeholder="100..."
                type="number"
                :validate="validate"
                v-model="dados.in_chunk_guias"
              />
            </div>
            <div class="col col-12 col-md-3" v-if="1 == 0">
              <az-input
                label="Limite de Valor para Atendimento sem Senha"
                type="number"
                :validate="validate"
                v-model="dados.in_limite_itens_guia"
              />
            </div>
            <div class="col col-12 col-md-3">
              <az-input
                label="Versão da TISS"
                type="select"
                optionsMode="json"
                :optionsList="versoesTiss"
                optionsData="id"
                :validate="validate"
                v-model="dados.st_versao_tiss"
              />
            </div>
          </div>

          <!-- Outras Configurações -->
          <az-sub-title title="Opções" class="mt-2" />
          <az-input
            label="Gerar a consulta em guia separada"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_consulta_independente"
          />

          <az-input
            label="Gerar a guia de consulta"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_consulta"
          />

          <az-input
            label="Gerar consulta em guia SP/SADT, quando for telessaúde"
            type="checkbox-group"
            :validate="validate"
            v-if="dados.fl_guia_consulta"
            v-model="dados.fl_consulta_em_sadt_telemed"
          />

          <az-input
            label="Guias de tratamento seriado emitidas separadas"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_seriado_separada"
          />

          <template v-if="!tratamento_seriado_incremental">
            <az-input
              label="Tratamento Seriado com Guia Incremental"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_tratamento_seriado_incremental" />

            <div class="small text-muted mb-3" v-if="dados.fl_tratamento_seriado_incremental">A cada atendimento realizado, o procedimento é incluído na guia original de tratamento seriado.</div>
          </template>

          <az-input
            label="Permitir editar o número da guia do prestador"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_editar_guia_prestador"
          />

          <div class="row">
              <div class="col col-12" :class="dados.fl_editar_guia_operadora ? 'col-md-6' : 'col-md-12'">
                  <az-input
                    label="Permitir editar o número da guia do atribuído pela operadora"
                    type="checkbox-group"
                    :validate="validate"
                    v-model="dados.fl_editar_guia_operadora"
                  />
              </div>
              <div class="col col-12 col-md-6" v-if="dados.fl_editar_guia_operadora">
                  <az-input
                    placeholder="Quantidade de dígitos"
                    type="number"
                    :validate="validate"
                    v-model="dados.in_numero_operadora_digitos"
                  />
              </div>
          </div>

          <az-input
            label="Não lançar novos itens em guia com número atribuído pela operadora e sem senha."
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_num_atrib_fechada"
          />

          <az-input
            label="Não consolidar/agrupar procedimentos nas guias"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_nao_consolidar_procedimentos"
          />

          <az-input
            v-if="!dados.fl_nao_consolidar_procedimentos"
            label="Ignorar valor unitário ao consolidar/agrupar procedimentos nas guias"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_ignorar_valor_unitario_consolidar"
          />

          <az-input
            label="Guia de cirurgia separada por membro da equipe"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_cirurg_membro_separado"
          />

          <az-input
            label="Gerar guia unificada para atendimentos com médicos diferentes (quando lançado junto)"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_medico_dif_guia_unica"
          />

          <az-input
            label="Gerar guia para data do envio da solicitação de autorização (ao invés de ser para data do atendimento)"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_dt_aut"
          />

          <az-input
            label="Realizar redução considerando todos os atendimentos do dia do paciente."
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_reducao_dia"
          />

          <az-input
            label="Não incluir procedimentos com equipe e valor zerado na guia"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_nao_exibir_equipe_zerado"
          />

          <az-input
            label="Valor unitário cheio quando houver redução"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_valor_unit_cheio_red"
          />

          <az-input
            label="Número da Guia do Prestador Obrigatório"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_prest_obrig"
          />

          <az-input
            label="Número da Guia Atribuído pela Operadora Obrigatório"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_guia_oper_obrig"
          />

          <az-input
            label="Distribuir datas de terapia na guia física, como também no XML da fatura"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_terapia_datas_guia"
            v-if="terapia_datas_xml_fatura"
          />

          <az-input
            label="Unificar guias SADT autorizadas"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_unificar_guias_autorizacao"
          />

          <!-- Talvez voltar -->
          <az-input
            v-if="1 == 0"
            label="Operadora fornece número da Guia"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_envia_numero_guia"
          />

          <az-input
            v-if="1 == 0"
            label="Honorários dos Médicos devem ser cobrados numa única guia (Fatura para médico)"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_cobranca_honorario_medico"
          />

          <az-input
            v-if="1 == 0"
            label="Os atendimentos exigem identificação biométrica para realização"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_identificacao_biometrica"
          />

          <az-input
            v-if="1 == 0"
            label="O código da empresa solicitante será preenchido com o CRM do médico"
            type="checkbox-group"
            :validate="validate"
            v-model="dados.fl_codigo_empresa_solicitante"
          />

          <!-- Outras Configurações para Guia TISS -->
          <template v-if="1 == 0">
            <az-sub-title title="Opções de Guia TISS" class="mt-3" />
            <az-input
              label="A guia de Honorário Individual deve ser impressa no lugar da guia SP/SADT"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_impressao_guia_honorario_individual"
            />

            <az-input
              label="Imprime Guia de Honorário Individual para Fatura Empresa"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_impressao_guia_honorario_empresa"
            />

            <az-input
              label="Taxas Solicitáveis devem sair em procedimentos e exames solicitados (SP/SADT)"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_taxa_solicitavel"
            />

            <az-input
              label="O profissional solicitante deve ser o contratado solicitante (SP/SADT)"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_profissional_solicitante"
            />

            <az-input
              label="Os itens com fatura para médico devem sair na guia da empresa com valor zerado"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_item_fatura_medico"
            />

            <az-input
              label="Os totais da Guia de Outras Despesas devem aparecer apenas na primeira página e zerado nas demais"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_total_guia_outras_despesas"
            />

            <az-input
              label="O custo operacional deve ser emitido separado do honorário médico"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_custo_operacional_separado"
            />

            <az-input
              label="Gerar uma guia de SP/SADT para cada senha de autorização"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_guia_sadt"
            />

            <az-input
              label="Consolidar os honorários cirúrgicos com a cirurgia"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_consolidar_honorario_cirurgico"
            />

            <az-input
              label="O custo operacional deve sair na guia de outras despesas ou na guia SP/SADT/Resumo de Internação"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_impressao_custo_operacional"
            />

            <az-input
              label="Consolidar os materiais e medicamentos na guia de outras despesas"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_consolidar_material_medicamento"
            />

            <az-input
              label="Usar guia de tratamento odontológico"
              type="checkbox-group"
              :validate="validate"
              v-model="dados.fl_usar_guia_tratamento_odontologico"
            />

          </template>

          <!-- Consultas de Exceção que devem gerar SADT -->
          <template v-if="dados.fl_guia_consulta">
            <az-sub-title title="Consultas que devem sair na Guia SADT" class="mt-3" />
            <div class="row mb-2">
              <div class="col col-12">
                <az-input
                  icon="fas fa-plus"
                  type="select"
                  optionsMode="aql"
                  service="procedimentos.index"
                  :optionsSync="false"
                  :optionsParm="{ ativos: true, where: { id_classe_procedimento: 1 } }"
                  v-model="novaConsulta"
                  @input="adicionarConsulta()"
                />
              </div>
              <div class="col col-12" v-for="(rom, im) in dados.guia_operadora_consultas" :key="im">
                <az-input type="checkbox-group" :label="rom.procedimento.search" v-model="rom.fl_guia_sadt">
                    <template v-slot:buttonposcb>
                        <div class="input-group-append" v-if="rom.id_guia_operadora_consulta">
                            <button type="button" class="btn" 
                                :class="rom.unidade_operacao_lista_count > 0 ? 'btn-outline-danger' : 'btn-outline-primary'"
                                data-toggle="tooltip" data-placement="top" title="Lista Unidades"
                                @click="unidade_operacao_lista(rom)">
                                <i class="fa-regular fa-building fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
              </div>
            </div>
          </template>

          <az-sub-title title="Coparticipação" class="mt-3" />
          <div class="row mb-2">
            <div class="col col-12">
              <az-input
                  type="select"
                  placeholder="Selecione..."
                  :optionsList="[
                    { id: 'N', search: 'Nenhuma' }, 
                    { id: 'A', search: 'Adicionar valor informado aos procedimentos' }, 
                    { id: 'W', search: 'Deduzir percentual fixo dos procedimentos' }, 
                    { id: 'D', search: 'Deduzir valor informado dos procedimentos' }, 
                    { id: 'T', search: 'Definido na tabela de preço' }, 
                    { id: 'P', search: 'Percentual fixo de coparticipação' }, 
                  ]"
                  optionsData="id"
                  v-model="dados.ch_tipo_copart" />
            </div>
          </div>

          <template v-if="dados.ch_tipo_copart == 'P' || dados.ch_tipo_copart == 'W'">
            <div class="row mb-2">
                <div class="col col-12 col-md-6">
                    <az-input
                        icon="fa fa-percent"
                        type="number"
                        placeholder="Percentual de Coparticipação"
                        v-model="dados.dc_copart_percent">
                    </az-input>
                </div>
            </div>
          </template>

        </div>
      </div>
    </div>

    <br><br><br>

    <unidade-operacao-lista ref="unidadeoperacaolista" @refresh="atualizar_rom" />

    <pre v-if="1 == 0">{{ dados }}</pre>
  </div>
</template>

<script>
import _ from 'lodash';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubTitle from "../../../util/AzSubTitle.vue";
import UnidadeOperacaoLista from '../../../shared/UnidadeOperacaoLista.vue';

export default {
  data() {
    return {
      dados: null,
      search: "",
      validate: false,
      versoesTiss: [
        { id: "020201", search: "02.02.01" },
        { id: "020203", search: "02.02.03" },
        { id: "030200", search: "03.02.00" },
        { id: "030201", search: "03.02.01" },
        { id: "030202", search: "03.02.02" },
        { id: "030300", search: "03.03.00" },
        { id: "030301", search: "03.03.01" },
        { id: "030302", search: "03.03.02" },
        { id: "030303", search: "03.03.03" },
        { id: "030400", search: "03.04.00" },
        { id: "030401", search: "03.04.01" },
        { id: "030500", search: "03.05.00" },
        { id: "040000", search: "04.00.00" },
        { id: "040001", search: "04.00.01" },
        { id: "040100", search: "04.01.00" },
        { id: "040200", search: "04.02.00" },
        { id: "040300", search: "04.03.00" }
      ],
      novaConsulta: "",
      contador_fatura_edit: false,
      contador_lote_fatura_edit: false,
      contador_fatura: null,
      contador_lote_fatura: null,
      tratamento_seriado_incremental: false, 
      terapia_datas_xml_fatura: false, 
      rom_unidades: null, 
    };
  },

  components: {
    AzBreakTitle,
    AzSubTitle,
    AzInput, 
    UnidadeOperacaoLista
  },

  props: ["id_operadora", "registro_ans"],

  methods: {
    unidade_operacao_lista (item) { 
        this.rom_unidades = item;
        this.$refs.unidadeoperacaolista.abrir('guiaOperadoraConsulta', item.id_guia_operadora_consulta);
    },

    atualizar_rom(item) { 
        if ( item ) { 
            this.rom_unidades.unidade_operacao_lista_count = item.length;
        }
    },

    editarContadorFatura() {
        if(this.contador_fatura_edit) {
            // atualizar o contador de fatura
             this.$util.atualizar(this, {
                service: "faturas",
                func: "contador_fatura_update",
                dados:  {
                    registro_ans: this.registro_ans,
                    contador: this.contador_fatura,
                },
                toast: true,
                final: () => {
                    this.load();
                },
            });

            this.contador_fatura_edit = false;
        } else {
            this.contador_fatura_edit = true;
        }
    },

    editarContadorLoteFatura() {
        if(this.contador_lote_fatura_edit) {
            // atualizar o contador de fatura
             this.$util.atualizar(this, {
                service: "faturas",
                func: "contador_lote_fatura_update",
                dados:  {
                    contador: this.contador_lote_fatura,
                },
                toast: true,
                final: () => {
                    this.contador_lote_fatura_edit = false;
                },
            });

            this.contador_lote_fatura_edit = false;
        } else {
            this.contador_lote_fatura_edit = true;
        }
    },

    adicionarConsulta () {
      if ( this.novaConsulta ) {
        if (
          !this.dados.guia_operadora_consultas.find(rom => {
            return rom.id_procedimento == this.novaConsulta.id_procedimento;
          })
        ) {
          this.dados.guia_operadora_consultas.push({
            id_guia_operadora_consulta: null,
            id_guia_operadora: this.dados.id_guia_operadora,
            id_procedimento: this.novaConsulta.id_procedimento,
            fl_guia_sadt: true,
            procedimento: this.novaConsulta,
          });

          this.$nextTick(() => {
            this.novaConsulta = "";
          });
        }
      }
    },

    incluir() {
      //
    },

    toggle() {
      //
    },

    atualizar() {
      this.$util.atualizar(this, {
        service: "guia_operadoras",
        func: "store",
        dados: this.dados,
        toast: true,
        reload: true
      });

      /*
            this.validate = true;

            this.$nextTick (() => {

                let invalids = $('.invalid');

                if ( invalids.length ) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else {

                    this.$store.commit('loading', true);

                    let query = { q: [
                        {
                            name: 'guia_operadoras.store',
                            id: 'atualizar',
                            parms: {
                                ...this.dados,
                            }
                        }
                    ]};

                    this.axios.post('/aql', query)
                        .then (res => {
                            if ( res.data.atualizar.status == 200 ) {

                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => {
                            this.$store.commit('loading', false);
                        });

                }

            });
            */
    },

    load() {
      this.validate = false;

      this.$store.commit("loading", true);

      let query = {
        q: [
          {
            name: "guia_operadoras.index",
            id: "lista",
            parms: {
              where: {
                id_operadora: this.id_operadora
              }
            }
          },
          {
            name: "faturas.contador_fatura",
            id: "contador",
            parms: {
              registro_ans: this.registro_ans ? this.registro_ans : '-'
            }
          },
          {
            name: 'configuracoes.index',
            id: 'configtratserinc',
            parms: {
              where: {
                st_slug: 'tratamento-seriado-incremental',
                fl_ativo: '1',
              }
            } 
          },
          {
            name: 'configuracoes.index',
            id: 'configdatasterapiaxml',
            parms: {
              where: {
                st_slug: 'distribuir-itens-terapia-xml-fatura',
                fl_ativo: '1',
              }
            } 
          },
        ]
      };

      this.axios
        .post("/aql?a=guia_operadoras", query)
        .then(res => {
          if (res.data.lista.status == 200) {
            this.dados = res.data.lista.data[0];
          }

          if (res.data.contador.status == 200) {
            this.contador_fatura = res.data.contador.data;
          }

          if ( res.data.configtratserinc && res.data.configtratserinc.status == 200 ) { 
            this.tratamento_seriado_incremental = ( _.get(res.data.configtratserinc.data, '0.st_valor') > 0 );
          }

          if ( res.data.configdatasterapiaxml && res.data.configdatasterapiaxml.status == 200 ) { 
            this.terapia_datas_xml_fatura = ( _.get(res.data.configdatasterapiaxml.data, '0.st_valor') > 0 );
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    }
  },

  mounted() {
    this.load();
  }
};
</script>
